//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Scrollbar from "@/components/scroll/Scrollbar";

export default {
  name: "ScrollbarWrapper",
  components: {
    Scrollbar,
  },
  props: {
    bottomSpace: {
      type: Object,
      default: () => ({
        in: 0,
        out: 0,
      }),
    },
    margins: {
      type: Boolean,
      default: false,
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
    scrollW: {
      type: Boolean,
      default: true,
    },
    version: {
      type: String,
      default: null,
    },
  },
};
